/**
 * Exposure header — home page:
 *   1. White above hero (is-at-top)
 *   2. Glass over hero/banner on scroll (is-floating) — smooth CSS transition
 *   3. Dismisses by sliding up + fading (is-dismissed) — own CSS transition
 *   4. Scroll back up → slides back in
 *
 * Inner pages: white always, subtle shadow when scrolled.
 */
(function () {
  function clamp(val, min, max) {
    return Math.min(max, Math.max(min, val));
  }

  function getThresholds(wrapper) {
    const pinAt       = parseInt(wrapper.dataset.floatStart    || '60',  10);
    const holdDist    = parseInt(wrapper.dataset.holdDistance  || '280', 10);
    const fadeDist    = parseInt(wrapper.dataset.fadeDistance  || '160', 10);
    return { pinAt, fadeDist, dismissAt: pinAt + holdDist };
  }

  window.ExposureHeaderScroll = {
    getThresholds,

    /* Last position we evaluated, so we can detect scroll direction. */
    _lastScrollTop: 0,

    updateWrapperState(wrapper, scrollTop) {
      if (!wrapper) return;

      const isOverHero  = wrapper.classList.contains('header-wrapper--over-hero');
      const fadeEnabled = wrapper.dataset.scrollFade === 'true';

      /* ── Inner pages ──────────────────────────────────────────── */
      if (!isOverHero || !fadeEnabled) {
        wrapper.classList.toggle('is-scrolled', scrollTop > 6);
        wrapper.classList.toggle('is-at-top',   scrollTop <= 6);
        this._lastScrollTop = scrollTop;
        return;
      }

      /* ── Home hero ────────────────────────────────────────────── */
      const { pinAt, fadeDist, dismissAt } = getThresholds(wrapper);

      const atTop    = scrollTop < pinAt;
      const progress = atTop ? 0 : clamp((scrollTop - pinAt) / fadeDist, 0, 1);

      /* Direction-aware hide/reveal: hide when scrolling down past the
         hero, reveal the moment the user scrolls back up. Ignore sub-pixel
         jitter so the header doesn't flicker. */
      const last      = this._lastScrollTop;
      const delta     = scrollTop - last;
      const goingDown = delta > 0;

      let dismissed = wrapper.classList.contains('is-dismissed');

      if (atTop) {
        dismissed = false;
      } else if (Math.abs(delta) > 4) {
        if (goingDown && scrollTop > dismissAt) {
          dismissed = true;
        } else if (!goingDown) {
          dismissed = false;
        }
      }

      const floating = !atTop && !dismissed;

      wrapper.classList.toggle('is-at-top',    atTop);
      wrapper.classList.toggle('is-floating',  floating);
      wrapper.classList.toggle('is-dismissed', dismissed);
      wrapper.style.setProperty('--header-scroll-progress', String(progress));

      this._lastScrollTop = scrollTop;
    },
  };
})();
